'use client';

import { IS_SSR } from '@libs/common-next';

import { getSearchStats, type SearchStats, setSearchStats } from '../helpers/storageSearch';

type AnalyticsContext = {
    getSearchStats: () => SearchStats;
    setSearchStats: (stats: SearchStats) => void;
};

/**
 * useAnalyticsContext
 * @description As we currently changing entire apps on navigation so, context is not enough to track the user's journey.
 *              We need to store the user's journey in the local storage to track.
 */
export const useAnalyticsContext = (): AnalyticsContext => {
    // check if we are on client side and local storage is available.
    if (IS_SSR) {
        return {
            getSearchStats: () => ({}) as SearchStats,
            setSearchStats: () => undefined,
        };
    }

    return {
        getSearchStats,
        setSearchStats,
    };
};
